export default "__VITE_ASSET__GzqK13Tj__"